module.exports = __webpack_public_path__ + "static/media/empty.0555b3a2.svg";